import React, { useState } from 'react';
import { Heading, Section, Search } from '@carbon/react';
import PageContainer from '../components/PageContainer';
import './Blog.css';

// Dummy podaci - aktivnosti i dešavanja u domu.
// Kada backend endpoint bude gotov, zameniti ovaj niz odgovorom API-ja
// (očekivana polja: id, author, authorRole, date, category, title, content, imageUrl).
const POSTS = [
  {
    id: 1,
    author: 'Dr Milica Jovanović',
    authorRole: 'Medicinska sestra',
    date: '18.09.2026.',
    category: 'Nega',
    title: 'Kako negovati kožu starijih osoba zimi',
    content:
      'Zimski meseci donose suv vazduh i hladnoću koji dodatno isušuju osetljivu kožu starijih osoba. Preporučuje se korišćenje bogatih hidratantnih krema bez alkohola, redovno podmazivanje kože nakon kupanja i izbegavanje vruće vode. Ne zaboravite ni na zaštitu usana i ruku, kao i na dovoljan unos tečnosti tokom dana.',
    imageUrl: 'https://picsum.photos/seed/cuvarkuca-nega/900/560',
  },
  {
    id: 2,
    author: 'Jelena Petrović',
    authorRole: 'Organizator aktivnosti',
    date: '12.09.2026.',
    category: 'Aktivnosti',
    title: 'Značaj socijalne interakcije u domu',
    content:
      'Druženje, razgovor i zajedničke aktivnosti ključni su za mentalno zdravlje korisnika. Redovne grupne aktivnosti poput vežbi, kreativnih radionica i muzičkih susreta pomažu u očuvanju kognitivnih funkcija i smanjenju osećaja usamljenosti. Preporučuje se uključivanje korisnika u planiranje aktivnosti kako bi se ojačao osećaj pripadnosti.',
    imageUrl: 'https://picsum.photos/seed/cuvarkuca-drustvo/900/560',
  },
  {
    id: 3,
    author: 'Nutricionista Ana Marković',
    authorRole: 'Nutricionista',
    date: '05.09.2026.',
    category: 'Ishrana',
    title: 'Pravilna ishrana i hidratacija tokom leta',
    content:
      'Visoke temperature povećavaju rizik od dehidratacije. Kod starijih osoba osećaj žeđi je često smanjen, pa je neophodno podsećati ih da piju vodu tokom celog dana. Obroci treba da budu lagani, bogati voćem i povrćem, a tešku i masnu hranu treba izbegavati. Redovno merenje unosa tečnosti pomaže u prevenciji komplikacija.',
    imageUrl: 'https://picsum.photos/seed/cuvarkuca-ishrana/900/560',
  },
  {
    id: 4,
    author: 'Dr Milica Jovanović',
    authorRole: 'Medicinska sestra',
    date: '28.08.2026.',
    category: 'Bezbednost',
    title: 'Prevencija padova u staračkom domu',
    content:
      'Padovi su jedan od najčešćih uzroka povreda kod starijih osoba. Ključne mere prevencije uključuju dobro osvetljenje prostorija, uklanjanje tepiha i prepreka, postavljanje rukohvata u kupatilima i redovnu fizičku aktivnost koja jača mišiće i ravnotežu. Važno je i da osoblje bude obučeno da prepozna rizične korisnike.',
    imageUrl: 'https://picsum.photos/seed/cuvarkuca-bezbednost/900/560',
  },
  {
    id: 5,
    author: 'Dr Nikola Ilić',
    authorRole: 'Lekar',
    date: '20.08.2026.',
    category: 'Zdravlje',
    title: 'Kako prepoznati rane znake demencije',
    content:
      'Zaboravnost je česta, ali nije uvek bezazlena. Rani znaci demencije uključuju ponavljanje istih pitanja, dezorijentaciju u poznatom okruženju, probleme sa rečima i promene raspoloženja. Ukoliko se ovi simptomi javljaju često i ometaju svakodnevni život, neophodno je obratiti se lekaru radi procene.',
    imageUrl: 'https://picsum.photos/seed/cuvarkuca-zdravlje/900/560',
  },
  {
    id: 6,
    author: 'Jelena Petrović',
    authorRole: 'Organizator aktivnosti',
    date: '14.08.2026.',
    category: 'Nega',
    title: 'Higijena sna kod starijih osoba',
    content:
      'Kvalitetan san je temelj dobrog zdravlja. Uspostavljanje redovne rutine odlaska na spavanje, izbegavanje kofeina u popodnevnim satima i mirna, zamračena soba značajno poboljšavaju kvalitet sna. Dnevna fizička aktivnost i izlaganje dnevnoj svetlosti takođe pomažu u regulaciji biološkog ritma.',
    imageUrl: 'https://picsum.photos/seed/cuvarkuca-san/900/560',
  },
];

// Inicijali autora za avatar (npr. "Dr Milica Jovanović" -> "MJ")
const getInitials = (name = '') => {
  const parts = name
    .replace(/^(dr|dr\.|nutricionista|prof\.?)\s+/i, '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const Blog = () => {
  const [query, setQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('Sve');
  const [expandedId, setExpandedId] = useState(null);
  const [failedImages, setFailedImages] = useState({});

  const categories = ['Sve', ...Array.from(new Set(POSTS.map((p) => p.category)))];

  const filtered = POSTS.filter((post) => {
    const matchesCategory = activeCategory === 'Sve' || post.category === activeCategory;
    const q = query.trim().toLowerCase();
    const matchesQuery =
      !q ||
      post.title.toLowerCase().includes(q) ||
      post.content.toLowerCase().includes(q) ||
      post.author.toLowerCase().includes(q);
    return matchesCategory && matchesQuery;
  });

  return (
    <PageContainer>
      <Section>
        <Heading style={{ marginBottom: '0.5rem' }}>Naš blog</Heading>
        <p className="blog-intro">
          Aktivnosti i dešavanja u domu — podelite trenutke sa našom zajednicom.
        </p>

        <div className="blog-toolbar">
          <Search
            size="lg"
            labelText="Pretraga bloga"
            placeholder="Pretraži objave..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="blog-search"
          />
          <div className="blog-categories">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                className={`blog-category ${activeCategory === cat ? 'is-active' : ''}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {filtered.length === 0 ? (
          <p className="blog-empty">Nema objava koje odgovaraju pretrazi.</p>
        ) : (
          <div className="blog-feed">
            {filtered.map((post) => {
              const isExpanded = expandedId === post.id;
              const showImage = post.imageUrl && !failedImages[post.id];
              return (
                <article className="blog-post" key={post.id}>
                  {/* Zaglavlje objave - autor */}
                  <header className="blog-post__header">
                    <div className="blog-post__avatar" aria-hidden="true">
                      {getInitials(post.author)}
                    </div>
                    <div className="blog-post__meta">
                      <span className="blog-post__author">{post.author}</span>
                      <span className="blog-post__sub">
                        {post.authorRole}
                        {' · '}
                        {post.date}
                      </span>
                    </div>
                    <span className="blog-post__category">{post.category}</span>
                  </header>

                  {/* Slika objave */}
                  {showImage && (
                    <div className="blog-post__media">
                      <img
                        src={post.imageUrl}
                        alt={post.title}
                        loading="lazy"
                        onError={() =>
                          setFailedImages((prev) => ({ ...prev, [post.id]: true }))
                        }
                      />
                    </div>
                  )}

                  {/* Sadržaj objave */}
                  <div className="blog-post__body">
                    <h3 className="blog-post__title">{post.title}</h3>
                    <p className={`blog-post__text ${isExpanded ? 'is-expanded' : ''}`}>
                      {post.content}
                    </p>
                    <button
                      type="button"
                      className="blog-post__toggle"
                      onClick={() => setExpandedId(isExpanded ? null : post.id)}
                    >
                      {isExpanded ? 'Prikaži manje' : 'Pročitaj više'}
                    </button>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </Section>
    </PageContainer>
  );
};

export default Blog;
